export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouvel utilisateur interne"])},
        "first_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prénom"])},
        "last_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rôle"])},
        "role_admin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin"])},
        "role_sales_manager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Animateur"])},
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créer"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New internal user"])},
        "first_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["First name"])},
        "last_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Last name"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Role"])},
        "role_admin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin"])},
        "role_sales_manager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales field manager"])},
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create"])}
      }
    }
  })
}
